import { Text } from '@rbilabs/universal-components';

export const PriceAndCaloriesText = Text.withConfig({
  variant: 'copyTwo',
  textAlign: 'center',
  margin: 0,
  padding: 0,
});

export const Price = Text.withConfig({
  variant: 'copyTwo',
  fontWeight: 'bold',
});
